var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.strands.length > 0)?_c('span',{staticClass:"strands"},[_vm._v(" "+_vm._s(_vm.$tc("eloListCard.strands", _vm.strands.length))+": "+_vm._s(_vm.strands.join(", "))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }